module.exports = __webpack_public_path__ + "h5/img/noCoupon.981e4c9b.png";